import PdvFinalizadoraService from "@/services/PdvFinalizadoraService";

export const pdvFinalizadora = {
  namespaced: true,
  state: {
    configuracao: {},
  },
  actions: {
    getConfiguracaoPdvFinalizadora() {
      return PdvFinalizadoraService.GetConfiguracao().then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    postFinalizadoraPdv({ commit }, payload) {
      return PdvFinalizadoraService.PostFinalizadora(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    putFinalizadoraPdv({ commit }, payload) {
      return PdvFinalizadoraService.PutFinalizadora(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    deleteFinalizadoraPdv({ commit }, payload) {
      return PdvFinalizadoraService.DeleteFinalizadora(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    postPlanoPagamentoFinalizadoraPdv({ commit }, payload) {
      return PdvFinalizadoraService.PostPlanoPagamento(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    putPlanoPagamentoFinalizadoraPdv({ commit }, payload) {
      return PdvFinalizadoraService.PutPlanoPagamento(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    deletePlanoPagamentoFinalizadoraPdv({ commit }, payload) {
      return PdvFinalizadoraService.DeletePlanoPagamento(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
  },
  mutations: {},
};

export default pdvFinalizadora;
